import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="container-site py-24 lg:py-32 text-center">
      <p className="font-heading text-7xl sm:text-8xl font-extrabold text-brand-red/15">404</p>
      <h1 className="mt-4 text-3xl sm:text-4xl font-extrabold text-brand-dark">This page doesn't exist</h1>
      <p className="mt-4 text-sm text-brand-muted max-w-md mx-auto leading-relaxed">The page you're looking for may have moved or never existed. Let's get you back to exploring loan options.</p>
      <Link to="/" data-testid="not-found-home-btn" className="btn-primary mt-8"><ArrowLeft size={15} /> Back to Home</Link>
    </div>
  );
}
